
import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export const addEditMultiPaymentsModalSlice = createSlice({
    name: 'addEditMultiPaymentsModal',
    initialState: {
        showModal: false,
        title: 'New Multi Payments',
        editMode: false,
        acc_id: 2,
        formData: {
            multipay_desc: '',
            multipay_date: moment().format('DD-MM-YYYY'),
            multipay_dc: 'C',
            jvtype_id: 33,
            multipay_status: '',
            multipay_value_date: moment().format('DD-MM-YYYY'),
            acc_num: '',
            multipay_ref: '',
            multipay_num: '',
            paymentmode_id: '',
            chart_id: '',
            multipay_doc: '',
            multipayDetails: [],
            multipay_doc: '',
            multipay_doc_prev: ''
        }
    },
    reducers: {
        toggleMultiPaymentsModal: (state, action) => {
            state.showModal = !state.showModal
            state.title = (action.payload && action.payload.title) ? action.payload.title : 'New Multi Payments'
            state.editMode = (action.payload && action.payload.editMode) ? action.payload.editMode : false
            state.acc_id = (action.payload && action.payload.acc_id) ? action.payload.acc_id : 2
            state.formData = (action.payload && action.payload.formData) ? { ...action.payload.formData } : {
                multipay_desc: '',
                multipay_date: moment().format('DD-MM-YYYY'),
                multipay_dc: 'C',
                jvtype_id: 33,
                multipay_status: '',
                multipay_value_date: moment().format('DD-MM-YYYY'),
                acc_num: '',
                multipay_ref: '',
                multipay_num: '',
                paymentmode_id: '',
                chart_id: '',
                multipayDetails: [],
                multipay_doc: (action.payload && action.payload.multipay_doc) ? action.payload.multipay_doc : '',
                multipay_doc_prev: (action.payload && action.payload.multipay_doc_prev) ? action.payload.multipay_doc_prev : ''
            }
        }
    },
});

export const { toggleMultiPaymentsModal } = addEditMultiPaymentsModalSlice.actions;
export default addEditMultiPaymentsModalSlice.reducer;
